import './input-number-validation'
import './input-letter-validation'
import './input-comment-validation'
import './resize-image'
import './mobile-menu'
class Elements {
	constructor() {
		this.selectors = {
			document: document,
			category_menu: '.category_menu',
			category_more: '#category_menu_more',
			// category_submenu_more: '#category_submenu_more',
			sub_category_more: '.second_category',
			category_toggle_btn: '.category_toggle_btn',
			sendMailForm: '#subscribe_form',
			sendMailFormMobile: '#subscribe_form_mobile',
			sendFooterSubscribe: '.js-subscribe-footer',
			js_phone: '#js_phone',
			langDropdown: '#open_lang_dropdown',
			burger_nav : '.burger_nav',
			mobileNav: '.mobile_nav',
			burger_search_mobile : '.search_btn_mobile',			
			category_item_link : '.pages_list_item_url',
			categoryMenu: '#mobile_categories',
			navPages: '#header .pages_list_item',
			viberMobileLink: '.footer_mobile .icon3-viber',
			shareBlock: '#js-share-block',
			langDropdownOpen: '.lang_dropdown'					
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		self = this;

		// Change language
		this.nodes.document.on('click', ".js-lang", (e) => {
			e.preventDefault();
			var $this = $(e.currentTarget);
			if(typeof TOPBAR !== 'undefined'){
				TOPBAR.setLang(String($this.data('href')))
			} else {
				var expires;
				var url = window.location.pathname + window.location.search;
				var new_url = url.replace($this.data('currentLang'), $this.data('href'));
				var date = new Date();
				date.setTime(date.getTime() + (20 * 24 * 60 * 60 * 1000));
				expires = "expires=" + date.toUTCString();
				document.cookie = "simpalsid.lang=" + $this.data('href') + "; " + expires + ";path=/";
				window.location.href = new_url;
			}
		});		

		for (let page of Array.from(this.nodes.navPages)) {
			$(page).hasClass('has_child') ? 
				$(page).children('.has_child_link').on('click', e => e.preventDefault()) 
				: '';
		}

		// Banner without btn
		let prevTitleBanner = $('#slick_banner').data('arrow-prev-title');
    	let nextTitleBanner = $('#slick_banner').data('arrow-next-title');
		$("#slick_banner").slick({
			autoplay: true,
			dots: true,
			infinite: true,
			lazyLoad: 'ondemand',
			speed: 1000,
			accessibility: false,
			prevArrow: '<button class="slick-prev" title="' + prevTitleBanner + '"><i class="icon1-arrow-left"></i></button>',
			nextArrow: '<button class="slick-next" title="' + nextTitleBanner + '"><i class="icon1-arrow-right"></i></button>',
			fade: true,
			cssEase: 'linear',
			lazyLoad: 'ondemand',
			responsive: [{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: true
				}
			}]
		});

		// Banner with btn
		let prevTitleBannerBtn = $('#slick_banner_btn').data('arrow-prev-title');
    	let nextTitleBannerBtn = $('#slick_banner_btn').data('arrow-next-title');
		$("#slick_banner_btn").slick({
			autoplay: true,
			dots: true,
			infinite: true,
			lazyLoad: 'ondemand',
			speed: 1000,
			accessibility: false,
			prevArrow: '<button class="slick-prev" title="' + prevTitleBannerBtn + '"><i class="icon1-arrow-left"></i></button>',
			nextArrow: '<button class="slick-next" title="' + nextTitleBannerBtn + '"><i class="icon1-arrow-right"></i></button>',
			fade: true,
			cssEase: 'linear',
			lazyLoad: 'ondemand',
			responsive: [{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: true
				}
			}]
		});

		// Banner when category
		let prevTitleBanner2 = $('#slick_banner_2').data('arrow-prev-title');
    	let nextTitleBanner2 = $('#slick_banner_2').data('arrow-next-title');
		$("#slick_banner_2").slick({
			autoplay: true,
			dots: true,
			infinite: true,
			speed: 1000,
			accessibility: false,
			prevArrow: '<button class="slick-prev" title="' + prevTitleBanner2 + '"><i class="icon1-arrow-left"></i></button>',
			nextArrow: '<button class="slick-next" title="' + nextTitleBanner2 + '"><i class="icon1-arrow-right"></i></button>',
			fade: true,
			cssEase: 'linear',
			lazyLoad: 'ondemand',
			responsive: [{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: true
				}
			}]
		});

		// Banner in container
		let prevTitleBanner3 = $('#slick_banner_3').data('arrow-prev-title');
    	let nextTitleBanner3 = $('#slick_banner_3').data('arrow-next-title');
		$("#slick_banner_3").slick({
			autoplay: true,
			dots: true,
			infinite: true,
			speed: 1000,
			accessibility: false,
			prevArrow: '<button class="slick-prev" title="' + prevTitleBanner3 + '"><i class="icon1-arrow-left"></i></button>',
			nextArrow: '<button class="slick-next" title="' + nextTitleBanner3 + '"><i class="icon1-arrow-right"></i></button>',
			fade: true,
			cssEase: 'linear',
			lazyLoad: 'ondemand',
			responsive: [{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: true
				}
			}]
		});

		// Open/Close Lang Dropdown for 3 languages
		this.nodes.document.on('click', "#open_lang_dropdown", (e) => {
			e.preventDefault();
			$('.lang_dropdown').toggleClass('opened');
		});


		// Toggle height of category menu
		this.nodes.category_more.on('click', (e) => {
			const $this = $(e.currentTarget);
			$this.closest('.category_menu').toggleClass('opened');
		});	

		// Toggle height of category Submenu
		this.nodes.sub_category_more.on('click', (e) => {
			const $this = $(e.currentTarget);
			console.log('click')
			$this.closest('.category_submenu').toggleClass('opened');
		});

		// Open/Close category menu
		$(document).mouseup(e => {		
			let htmlArr = [
				this.nodes.category_toggle_btn, 
				this.nodes.js_phone, 
				this.nodes.burger_nav,				
				this.nodes.mobileNav,
				this.nodes.shareBlock,
				this.nodes.langDropdownOpen,
				this.nodes.category_more,
				// this.nodes.category_submenu_more,
				this.nodes.sub_category_more
			];	
			let activeCatLink = '';
			
			if (this.nodes.category_item_link.length) {
				for (let link of Array.from(this.nodes.category_item_link)) {
					if ($(link).parent('.pages_list_item').find('.subcategory_block').hasClass('active')) {
						activeCatLink = $(link);
						htmlArr.push(activeCatLink);
					}
				}
			}
			
			function checkHtml(el) {
				return !$(el).is(e.target) && $(el).has(e.target).length === 0
			}	
			
			if (				
				htmlArr.every(checkHtml)
			) {
				if (this.nodes.category_toggle_btn.hasClass('category-menu-open') 
					&& !$('.phone_dropdown').hasClass('show')) {
					$('#header_category').slideToggle(300);	
					this.nodes.category_toggle_btn.removeClass('category-menu-open');
				}  else if (!this.nodes.category_toggle_btn.hasClass('category-menu-open') 
					&& $('.phone_dropdown').hasClass('show')) {
					$('.phone_dropdown').removeClass('show');
				} else if (this.nodes.burger_nav.hasClass('open')) {
					this.nodes.burger_nav.removeClass('open');
					$('.mobile_nav_overlay').removeClass('open');
					$('#header_mobile').removeClass('open_dropdown')
					$('.mobile_nav').slideToggle(300);
				} else if (this.nodes.langDropdownOpen.hasClass('opened')) {
					this.nodes.langDropdownOpen.removeClass('opened');				
				} else if(this.nodes.category_toggle_btn.hasClass('category-menu-open')
					&& $('.phone_dropdown').hasClass('show')) {
					$('#header_category').slideToggle(300);	
					this.nodes.category_toggle_btn.removeClass('category-menu-open');
					$('.phone_dropdown').removeClass('show');				
				} else if (this.nodes.category_item_link.length) {
					for (let link of Array.from(this.nodes.category_item_link)) {
						if ($(link).parent('.pages_list_item').find('.subcategory_block').hasClass('active')) {
							$('.pages_list_item .subcategory_block.active').slideUp(300);
							$('.subcategory_block').removeClass('active')
						}
					}
				} else {
					return true
				}			
			}			
		})

		this.nodes.category_toggle_btn.on('click', (e)=> {
			e.preventDefault();			
			const $this = $(e.currentTarget);
			$this.toggleClass('category-menu-open');
			if (!$this.hasClass('hover') && !$this.hasClass('category_open')) {
				$this.siblings('.category_menu').slideToggle(300);
			}
			if ($this.hasClass('category_open') && !$('body').hasClass('is-index')) {
				$this.siblings('.category_menu').slideToggle(300);
			}
		});
		
		// Open/Close subcategory menu
		this.nodes.category_item_link.on('click', (e)=> {
			var $this = $(e.currentTarget);
			if (($this.parent('.pages_list_item').find('.subcategory_block')).length > 0 ){
				if($this.parent('.pages_list_item').find('.subcategory_block').hasClass('active')){
					e.preventDefault();
					$('.pages_list_item .subcategory_block.active').slideUp(300);
					$('.subcategory_block').removeClass('active')
				}
				else {
					e.preventDefault();
					$('.pages_list_item .subcategory_block.active').slideUp(300);
					$('.pages_list_item .subcategory_block').removeClass('active');
					$this.parent('.pages_list_item').find('.subcategory_block').slideDown(300);
					$this.parent('.pages_list_item').find('.subcategory_block').addClass('active');
				}
			}
		});				

		// Open/Close Burger Menu
		this.nodes.burger_nav.on('click', function(e){
			e.preventDefault();
			$('.burger_nav').toggleClass('open');
			if ($('#header_mobile').hasClass('scrolling_down')) $('#header_mobile').removeClass('scrolling_down') && $(window).scrollTop(0); 
			if ($('#header_mobile').hasClass('scrolling_up')) $('#header_mobile').removeClass('scrolling_up') && $(window).scrollTop(0);
			$('.mobile_nav_overlay').toggleClass('open');
			$('#header_mobile').toggleClass('open_dropdown')
			$('.mobile_nav').slideToggle(300);
		})

		// Open/Close Search
		this.nodes.burger_search_mobile.on('click', function(e){
			e.preventDefault();			
			$('.search').toggleClass('open');
		})

		// Product Quantity
		$('.js-quantity ').keypress(event => (event.key).match(/^[0-9]+$/) ? true : false)

		this.nodes.document.on('click', '.js-product-add-down, .js-product-add-up', function(e){
			e.preventDefault();
			var $this = $(this),
				val = parseInt($this.siblings('.js-quantity').val())
			if ($this.is('.js-product-add-down')){
				if (val > 1){
					$this.siblings('.js-quantity').val( val - 1 )
				}
			} else {
				$this.siblings('.js-quantity').val( val + 1 )
			}
		});

		// DropDown Phone
		this.nodes.js_phone.on('click', function(e){
			// If dropdown opens on click effect, use this
			$('.phone_dropdown').toggleClass('show');			
		});			

		$(document).ready(()=>{
			// Recaptcha subscribe forms
			function success(thisForm, confirmBlock) {
				thisForm[0].reset();
				$(confirmBlock).addClass('active');
				setTimeout(() => {
					$(confirmBlock).removeClass('active');
					if ($('#captcha_container_submit').length) {
						$('#captcha_container_submit').remove();
						$('.subscribe_two_form').find('input[type="submit"]').prop('disabled', true);
					}
					if ($('#captcha_container_submit_mobile').length) {
						grecaptcha.reset();
						$('#subscribe_form_mobile').find('input[type="submit"]').prop('disabled', true);
					}
				}, 3000);
			};
			function error(errorBlock, errors) {
				if (errors){
					$(errorBlock).text(errors).addClass('active');
				} else{
					$(errorBlock).addClass('active');
				}
				setTimeout( ()=>{
					$(errorBlock).removeClass('active')
				},3000)
			};
			// Desktop form
			if ($('#js-subscribe-btn').hasClass('g-recaptcha')) {				
				const recaptchaKey = $('#js-subscribe-btn').data('sitekey');
				grecaptcha.ready(() => {
					grecaptcha.execute(`${recaptchaKey}`, {action: 'submit'})				
				});
				window.afterInvisActivated = function(){
					const $this = $('#subscribe_form'),
						data  = $this.serialize();									
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? success($this, '#subscribe_confirmation') : grecaptcha.reset();
					});
				}
			} else {
				this.nodes.sendMailForm.on('submit', function(e){
					e.preventDefault();
					const $this = $(e.currentTarget),
						data  = $this.serialize();
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? success($this, '#subscribe_confirmation') : error('#subscribe_error', resp.errors);
					});
				});
			}
			// Mobile form
			if ($('#js-subscribe-mobile-btn').hasClass('g-recaptcha')) {				
				const recaptchaKeyMobile = $('#js-subscribe-mobile-btn').data('sitekey');
				grecaptcha.ready(() => {
					grecaptcha.execute(`${recaptchaKeyMobile}`, {action: 'submit'})				
				});
				window.afterInvisActivatedMobile = function(){
					const $this = $('#subscribe_form_mobile'),
						data  = $this.serialize();									
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? success($this, '#subscribe_confirmation_mobile') : grecaptcha.reset();
					});
				}
			} else {
				this.nodes.sendMailFormMobile.on('submit', function(e){
					e.preventDefault();
					const $this = $(e.currentTarget),
						data  = $this.serialize();
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? 
							success($this, '#subscribe_confirmation_mobile') : error('#subscribe_error_mobile', resp.errors);
					});
				});
			}
			// Viber mobile link
			function changeViberLink() {				
				const mobileLink = $('.footer_mobile .icon3-viber').parent(),
					changedLink = mobileLink.prop('href').split('+').join('');
				mobileLink.prop('href', changedLink);
			} 
			this.nodes.viberMobileLink.length ? changeViberLink() : '';
		});

		// Subscribe Footer Form
		this.nodes.sendFooterSubscribe.on('submit', function(e){
			e.preventDefault();
			const $this = $(e.currentTarget);
			$.post($this.attr('action'),$this.serialize()).then(resp => {
				if (resp.success){
					$this[0].reset()
					$this.find('#subscribe-confirmation-footer').addClass('active')
					setTimeout( ()=>{
						$this.find('#subscribe-confirmation-footer').removeClass('active')
					},3000)
				}
			});

		});		
	}
}
new Elements();
